const packageJson = require('../package.json');
//window.alert("i am config");
function getEnv(key) {
  // prefer runtime-injected values when present (accept empty string and false)
  if (typeof window !== 'undefined' && window.__RUNTIME__
    //  && Object.prototype.hasOwnProperty.call(window.__RUNTIME__, key)
  ) {
    return window.__RUNTIME__[key];
  }
  if (typeof process !== 'undefined' && process.env && process.env[key] !== undefined) {
    return process.env[key];
  }
  return undefined;
}

const config = {
  title: packageJson.title,

  /**
   * @type {String} '0.0.1'
   * @description Application version.
   * After the release of the new version, it is reset to the default settings.
   */
  version: packageJson.version,

  /**
   * @type {String} 'localStorage' | 'sessionStorage'
   * @description Storage for user settings and sessions.
   */
  storage: 'localStorage',

  /**
   * @type {String} 'vva_'
   * @description Key prefix for data in storage.
   */
  prefix: 'vva_',

  /**
   * @type {Number} 604800
   * @description User session storage time in seconds.
   * Default 7 days
   */
  ttl: /* 7 * 24 * 60 * */ 60,

  /**
   * @type {Object}
   * @description Default application settings.
   */
  settings: {
    locale: 'en',
    dense: false,
    footer: false,
    navbar: {
      show: true,
      dense: true,
      logo: true,
    },
    fullscreen: {
      show: false,
      btn: false,
    },
    settingsPanel: {
      show: false,
      btn: false,
    },
    theme: {
      index: 0,
      dark: false,
    },
  },

  /**
   * @type {boolean} true | false
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  // errorLog: 'production',

  VUE_APP_RECON_MODULE_URL: getEnv('VUE_APP_RECON_MODULE_URL'),

  VUE_APP_WALLET_MODULE_URL: getEnv('VUE_APP_WALLET_MODULE_URL'),
  VUE_APP_BILLING_SYSTEM_URL: getEnv('VUE_APP_BILLING_SYSTEM_URL'),
  VUE_APP_SWITCH_DASHBOARD_URL: getEnv('VUE_APP_SWITCH_DASHBOARD_URL'),
  VUE_APP_RECON_DASHBOARD_URL: getEnv('VUE_APP_RECON_DASHBOARD_URL'),
  VUE_APP_CIRCUIT_BREAKER_URL: getEnv('VUE_APP_CIRCUIT_BREAKER_URL'),


  VUE_APP_KEYCLOAK_REALM: getEnv('VUE_APP_KEYCLOAK_REALM'),
  VUE_APP_KEYCLOAK_URL: getEnv('VUE_APP_KEYCLOAK_URL'),
  VUE_APP_KEYCLOAK_CLIENT_ID: getEnv('VUE_APP_KEYCLOAK_CLIENT_ID'),
  VUE_APP_KEYCLOAK_ROLE: getEnv('VUE_APP_KEYCLOAK_ROLE'),
  VUE_APP_KEYCLOAK_PASSWORD: getEnv('VUE_APP_KEYCLOAK_PASSWORD'),

  // Ensure these environment-derived configs exist (with sensible defaults/aliases)
  VUE_APP_IS_PROXY: getEnv('VUE_APP_IS_PROXY'),
  isProxy: getEnv('VUE_APP_IS_PROXY') === true || String(getEnv('VUE_APP_IS_PROXY')) === 'true',

  // Aliases and defaults for dashboard/module/billing/wallet URLs/paths
  VUE_APP_BILLING_SYSTEM_PATH: getEnv('VUE_APP_BILLING_SYSTEM_PATH'),

  VUE_APP_CASHOUT_ADMIN_URL: getEnv('VUE_APP_CASHOUT_ADMIN_URL'),


  VUE_APP_SWITCH_MERCHANT_REPORT_PATH: getEnv('VUE_APP_SWITCH_MERCHANT_REPORT_PATH'),
  VUE_APP_SWITCH_PAYMENT_REPORT_PATH: getEnv('VUE_APP_SWITCH_PAYMENT_REPORT_PATH'),


  VUE_APP_TRANSACTION_SERVICE_URL: getEnv('VUE_APP_TRANSACTION_SERVICE_URL')


};

// config values are runtime-resolved when accessed

module.exports = config;
